/** Reading a chart's numbers as people type and paste them (spreadsheets, Swedish decimal commas, units). */

/** "124 615", "124615 kr", "12,5" → 124615, 12.5; empty or not a number → null. */
export function parseNumber(raw: string): number | null {
  const t = raw.replace(/\s/g, '').replace(/[^\d,.-]/g, '');
  if (!t) return null;
  // One comma and no dot is a decimal comma (Swedish); otherwise commas group thousands.
  const norm = /^-?\d+,\d+$/.test(t) ? t.replace(',', '.') : t.replace(/,/g, '');
  const n = Number(norm);
  return Number.isFinite(n) ? n : null;
}
/** A value as the grid shows it: Swedish grouping, up to two decimals, empty when there is none. */
export const showNumber = (n: number | undefined) => (n == null || !Number.isFinite(n) ? '' : n.toLocaleString('sv-SE', { maximumFractionDigits: 2 }));

/** A grid pasted from a spreadsheet (tabs between cells, a line per row): labels in the first column, series after; a first row of words names the series. */
export function parseGrid(text: string): { labels: string[]; datasets: Array<{ label?: string; values: number[] }> } | null {
  const lines = text.replace(/\r/g, '').split('\n').filter((l) => l.trim());
  if (lines.length < 1 || !lines.some((l) => l.includes('\t'))) return null;
  const rows = lines.map((l) => l.split('\t'));
  const width = Math.max(...rows.map((r) => r.length));
  const header = rows[0].slice(1).every((c) => parseNumber(c) == null && c.trim()) ? rows.shift()! : null;
  if (!rows.length || width < 2) return null;
  const series = Array.from({ length: width - 1 }, (_, si) => ({ ...(header?.[si + 1]?.trim() ? { label: header[si + 1].trim() } : {}), values: rows.map((r) => parseNumber(r[si + 1] || '') ?? 0) }));
  return { labels: rows.map((r) => r[0].trim()), datasets: series };
}
